import {
  Link,
  useLocation,
} from "react-router-dom";

import assignments from "../data/assignments";
import PublicLayout from "../layouts/PublicLayout";

function SavedJobs() {
  const location =
    useLocation();

  const isProfessionalPortal =
    location.pathname.startsWith(
      "/professional/"
    );

  const savedIds = JSON.parse(
    localStorage.getItem(
      "zethSavedAssignments"
    ) || "[]"
  );

  const savedJobs =
    assignments.filter(
      (assignment) =>
        savedIds.includes(
          assignment.id
        )
    );

  const content = (
    <section className="saved-jobs-section">
      <div className="saved-jobs-container">
        <div className="saved-jobs-header">
          <p className="section-label">
            Saved Jobs
          </p>

          <h1>
            Your Saved Assignments
          </h1>

          <p>
            Review assignments
            you've saved and apply
            whenever you're ready.
          </p>
        </div>

        {savedJobs.length === 0 ? (
          <div className="saved-empty">
            <h2>
              No saved assignments
            </h2>

            <p>
              Browse available
              assignments and click
              the ❤️ icon to save
              them.
            </p>

            <Link
              className="primary-button"
              to={
                isProfessionalPortal
                  ? "/professional/assignments"
                  : "/#assignments"
              }
            >
              Browse Assignments
            </Link>
          </div>
        ) : (
          <div className="saved-grid">
            {savedJobs.map(
              (assignment) => (
                <article
                  key={
                    assignment.id
                  }
                  className="saved-card"
                >
                  <span className="assignment-profession">
                    {
                      assignment.profession
                    }
                  </span>

                  <h2>
                    {
                      assignment.title
                    }
                  </h2>

                  <p>
                    {
                      assignment.facility
                    }
                  </p>

                  <p>
                    {
                      assignment.city
                    }
                    ,{" "}
                    {
                      assignment.province
                    }
                  </p>

                  <p>
                    {
                      assignment.shift
                    }{" "}
                    Shift
                  </p>

                  <h3>
                    $
                    {
                      assignment.pay
                    }
                    /hour
                  </h3>

                  <div className="saved-buttons">
                    <Link
                      className="secondary-button"
                      to={`/assignments/${assignment.id}`}
                    >
                      View Details
                    </Link>

                    <Link
                      className="primary-button"
                      to={
                        isProfessionalPortal
                          ? `/assignments/${assignment.id}`
                          : "/professional/login"
                      }
                    >
                      Apply
                    </Link>
                  </div>
                </article>
              )
            )}
          </div>
        )}
      </div>
    </section>
  );

  /*
  ========================================
  PROFESSIONAL PORTAL
  ========================================
  The ProfessionalLayout already provides
  the sidebar/header shell, so do not render
  PublicLayout here.
  */

  if (
    isProfessionalPortal
  ) {
    return content;
  }

  /*
  ========================================
  PUBLIC WEBSITE
  ========================================
  Public visitors still receive the normal
  public website header/navigation/footer.
  */

  return (
    <PublicLayout>
      {content}
    </PublicLayout>
  );
}

export default SavedJobs;